import Component from '@galactic-advisors/component-loader';
import axios from 'axios';
import { Toast, ToastStatusTypes } from '../../../../ts/toast.ts';

const DEFAULTS = {
  downloadReportButtonContainerElement:
    '[data-download-report-button-container]',
  selectAllButtonElement: '[data-select-all-button]',
  submitWispGenerationButtonElement: '[data-submit-wisp-generation-button]',
  unselectAllButtonElement: '[data-unselect-all-button]',
  selectableInputSelector: '[data-report-type-selection]',
  generationStatusElement: '[data-latest-wisp-generation-status]',
  generateWispButton: '[data-generate-wisp-button]',
  enableReportSelection: '[data-enable-report-selection]',
  latestReportUrlElementSelector: '[data-latest-report-url-element]',
  loaderElement: '[data-loader]',
  reportSelectionFormElement: '[data-report-selection-form]',
};

export default class CompanyWispGenerator extends Component {
  static selector = '[data-comp-company-wisp-generator]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.selectableInputs = this.$container.querySelectorAll(
      this.$options.selectableInputSelector
    );

    this.selectAllButton = this.$container.querySelector(
      this.$options.selectAllButtonElement
    );

    this.loader = this.$container.querySelector(this.$options.loaderElement);

    this.generateWispButton = this.$container.querySelector(
      this.$options.generateWispButton
    );

    this.unselectAllButton = this.$container.querySelector(
      this.$options.unselectAllButtonElement
    );

    this.generateWispReportRoute =
      this.generateWispButton.dataset.generateWispRoute;

    this.generationStatus = this.$container.querySelector(
      this.$options.generationStatusElement
    );

    this.latestReportUrlElement = this.$container.querySelector(
      this.$options.latestReportUrlElementSelector
    );

    this.reportStatusRoute = this.generateWispButton.dataset.reportStatusRoute;

    this.reportSelectionForm = this.$container.querySelector(
      this.$options.reportSelectionFormElement
    );

    this.downloadReportButtonContainer = this.$container.querySelector(
      this.$options.downloadReportButtonContainerElement
    );

    this.submitWispGenerationButton = this.$container.querySelector(
      this.$options.submitWispGenerationButtonElement
    );

    this.toast = Toast.instance;

    this.initListeners();
    this.updateStatuses();
  }

  determineButtonStatus(status) {
    if (status === 'Failed' || status === 'Finished') {
      this.submitWispGenerationButton.disabled = false;
      this.generateWispButton.disabled = false;
      this.loader.classList.add('d-none');
    }
  }

  selectAllInputs() {
    this.selectableInputs.forEach((input) => {
      if (input.disabled) {
        return;
      }
      input.checked = true;
    });
  }

  unselectAllInputs() {
    this.selectableInputs.forEach((input) => {
      input.checked = false;
    });
  }

  fetchJobStatus() {
    const generationStatus = axios({
      method: 'post',
      url: this.reportStatusRoute,
    }).catch((error) => {
      console.log(error.response.data.message);
    });

    return generationStatus;
  }

  requestReportGeneration(data) {
    const generationRequest = axios
      .post(this.generateWispReportRoute, data)
      .catch((error) => {
        this.toast.show(ToastStatusTypes.DANGER, error.response.data.message);
        console.error({ error });
      });
    return generationRequest;
  }

  updateStatuses() {
    return this.fetchJobStatus()
      .then((res) => {
        if (res && res.data) {
          this.updateGenerationStatus(res.data.data.status);
          this.determineButtonStatus(res.data.data.status);
          return res.data.data.status;
        }
        return false;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  updateGenerationStatus(status) {
    this.generationStatus.classList.remove('d-none');
    this.generationStatus.innerText = `Latest Report Generation Status: ${status}`;
    if (status !== 'Finished') {
      this.loader.classList.remove('d-none');
    }
  }

  startStatusInterval() {
    const runStatusUpdateInterval = async () => {
      const status = await this.updateStatuses();
      if (
        status === 'Queued' ||
        status === 'Executing' ||
        status === 'Retrying'
      ) {
        setTimeout(runStatusUpdateInterval, 10000);
      }
    };
    runStatusUpdateInterval();
  }

  initListeners() {
    this.selectableInputs &&
      this.selectableInputs.forEach((input) => {
        if (input.checked) {
          this.generateWispButton.disabled = false;
        }

        input.addEventListener('change', (e) => {
          if (e.target.checked) {
            this.generateWispButton.disabled = false;
          }
        });
      });

    this.selectAllButton &&
      this.selectAllButton.addEventListener('click', () => {
        this.selectAllInputs();
      });

    this.unselectAllButton &&
      this.unselectAllButton.addEventListener('click', () => {
        this.unselectAllInputs();
      });

    this.generateWispButton.addEventListener('click', (event) => {
      event.preventDefault();

      event.target.disabled = true;
      event.target.classList.add('d-none');
      this.downloadReportButtonContainer.classList.remove('d-flex');
      this.downloadReportButtonContainer.classList.add('d-none');
      this.reportSelectionForm.classList.remove('d-none');
      this.submitWispGenerationButton.classList.remove('d-none');
    });

    this.submitWispGenerationButton.addEventListener('click', async (event) => {
      event.preventDefault();

      const values = [];
      this.selectableInputs.forEach((input) => {
        if (input.checked) {
          values.push(input.value);
        }
      });

      await this.requestReportGeneration(values).then((response) => {
        this.toast.show(
          ToastStatusTypes.SUCCESS,
          'Requested Wisp Report Generation!'
        );

        this.submitWispGenerationButton.classList.add('d-none');
        this.submitWispGenerationButton.disabled = true;
        this.reportSelectionForm.classList.add('d-none');
        this.downloadReportButtonContainer.classList.add('d-flex');
        this.generateWispButton.disabled = true;
        this.generateWispButton.classList.remove('d-none');
        this.startStatusInterval();
      });
    });
  }
}
